import React from 'react';
import { TableFooter, TableRow } from '@material-ui/core';

const DataTableFooter = (props) => {
  return (
    <TableFooter>
      <TableRow>{props.children}</TableRow>
    </TableFooter>
  );
};

export default DataTableFooter;
